<template>
    <div class="dis-flex flex-m product-card-list mb-2 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 p-lr-0-sm">

        <input class="mr-2 select-product-checkbox dis-block" v-if="selectForDelete" type="checkbox" name="product-to-trash" :id="`thisProduct-${thisProduct.id}`" @change="selectThisProductForDelete($event, thisProduct)">
        <label class="w-full m-0" :for="`thisProduct-${thisProduct.id}`"
            :class="{
                'product-minimize': selectForDelete,
                'op-04': thisProduct.selectedForDelete
            }">
            <div class="card p-3 dis-flex w-full pos-relative">
                <div class="col-sm-12 p-0">
                    <div class="dis-flex flex-m mb-4 pos-relative">
                        <div class="dis-flex flex-m w-full z-ind-2">
                            <i class="uis uis-shopping-bag text-rose multi-popup small-pp mr-2 txt-normal fs-15 z-ind-2" desc="Product Item"></i>
                            <h6 class="mb-0 dis-flex font-h-6-name mobile-product-list-card text-back product-header small-header w-full mr-2 text-truncate pos-relative">{{ thisProduct.name[selectedLang] }}</h6>
                        </div>
                        <div class="buttons-whatch-attirute desktop-product-action-buttons ml-3">
                            <!-- <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Stock" v-if="!(thisProduct.selectedProductMenu == 'attributes')" @click="thisProduct.selectedProductMenu = 'attributes'">
                                <i class="uis uis-layer-group fs-12"></i>
                            </div> -->
                            <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Print Label">
                                <i class="uis uis-pricetag-alt fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Photos" v-if="!(thisProduct.selectedProductMenu == 'photos')" @click="thisProduct.selectedProductMenu = 'photos'">
                                <i class="uis uis-camera fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Product Info" v-if="!(thisProduct.selectedProductMenu == 'info')" @click="thisProduct.selectedProductMenu = 'info'">
                                <i class="uis uis-info-circle fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 pointer m-0" title="Product Overview" @click="$emit('setSelectedProductForEdit', thisProduct.id)">
                                <i class="uis uis-search fs-12"></i>
                            </div>
                        </div>
                        <div class="buttons-whatch-attirute mobile-product-action-buttons ml-3">
                            <template v-if="mobileActionBtnsOpened">
                                <!-- <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Stock" v-if="!(thisProduct.selectedProductMenu == 'attributes')" @click="thisProduct.selectedProductMenu = 'attributes'">
                                    <i class="uis uis-layer-group fs-12"></i>
                                </div> -->
                                 <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Print Label">
                                    <i class="uis uis-pricetag-alt fs-12"></i>
                                </div>
                                <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Photos" v-if="!(thisProduct.selectedProductMenu == 'photos')" @click="thisProduct.selectedProductMenu = 'photos'">
                                    <i class="uis uis-camera fs-12"></i>
                                </div>
                                <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Product Info" v-if="!(thisProduct.selectedProductMenu == 'info')" @click="thisProduct.selectedProductMenu = 'info'">
                                    <i class="uis uis-info-circle fs-12"></i>
                                </div>
                                <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Product Overview" @click="$emit('setSelectedProductForEdit', thisProduct.id)">
                                    <i class="uis uis-search fs-12"></i>
                                </div>
                            </template>
                            
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Actions" v-if="!mobileActionBtnsOpened" @click="mobileActionBtnsOpened = true">
                                <i class="uis uis-ellipsis-h fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Close Actions" v-else @click="mobileActionBtnsOpened = false">
                                <i class="uis uis-multiply fs-12"></i>
                            </div>
                        </div>

                        <div class="dis-flex flex-m flex-sb info-product-element product-item-tags-info pos-absolute z-ind-1" v-if="thisProduct.selectedProductMenu == 'info'">
                            <div v-trix-horizontal-slider class="dis-flex flex-m flex-w w-full fast-attribute-overview any-product-info-blocks-scroll snap-inline-element-info-product ml-0 pt-2 pb-2 mtb--05r">
                                <div class="created-attribute-components bg-gray-200 flex-m client-dashboard" title="Actual Stock">
                                    <span class="text-sm-d pr-2 bor-right-1">Quantity</span>
                                    <div class="dis-flex felx-m pl-2">
                                        <span class="text-sm-b fw-bold text-rose text-new-light">8960</span>
                                    </div>
                                </div>
                                <div class="created-attribute-components bg-gray-200 flex-m client-dashboard">
                                    <span class="text-sm-d pr-2 bor-right-1" title="Size Attribute">Size</span>
                                    <div class="dis-flex felx-m pl-2" title="Actual Size">
                                        <span class="text-sm-b fw-bold text-rose text-new-light">35gr</span>
                                    </div>
                                </div>
                                <div class="created-attribute-components bg-gray-200 flex-m client-dashboard" title="Color Attribute">
                                    <div class="color-attribute" title="Actual Color"></div>
                                    <span class="text-sm-b cl-txt-dark">GMO Free</span>
                                </div>
                                <div class="created-attribute-components bg-gray-200 flex-m client-dashboard" title="Material Attribute">
                                    <div class="photo-attribute strait-zoom mr-2 default" title="Actual Material"></div>
                                    <span class="text-sm-b cl-txt-dark">100% Cheese</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="photo-grid-row-action-btns w-full flex-r mb-3" :class="{
                            'dis-flex': thisProduct.selectedProductMenu == 'photos'
                        }">
                        <div class="buttons-whatch-attirute">
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Row View" v-if="thisProduct.photoViewType == 'grid'" @click="thisProduct.photoViewType = 'row'">
                                <i class="uis uis-grip-horizontal-line fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Grid View" v-else @click="thisProduct.photoViewType = 'grid'">
                                <i class="uis uis-apps fs-12"></i>
                            </div>
                        </div>
                    </div>

                    <div class="dis-flex flex-m pt-2">
                        <div class="dis-flex flex-m col-sm-12 p-0">
                            <div class="any-product-photo" v-if="!(thisProduct.selectedProductMenu == 'photos')">
                                <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                <!-- <img src="@/assets/images/product-06.jpg" alt=""> -->
                            </div>
                            <div v-trix-horizontal-slider class="any-product-info-blocks-scroll product-all-photo-rows snap-inline-element-info-product" v-if="thisProduct.selectedProductMenu == 'photos'"
                                :class="{'product-all-photo-grid': thisProduct.photoViewType == 'grid'}">
                                <div class="any-product-photo client-dashboard" v-for="idx in 5" :key="idx">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <!-- <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div> -->
                            </div>

                            <div v-trix-horizontal-slider class="any-product-info-blocks-scroll snap-inline-element-info-product pt-3 mt--1r" v-else-if="thisProduct.selectedProductMenu == 'info'">
                                <div class="info-product-element dis-flex flex-m text-back client-dashboard pos-relative">
                                    <i class="fs-15 uis uis-angle-double-left text-blue pos-absolute rt-1-1r"></i>
                                    <div class="dis-flex flex-column w-full">
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en" title="Sell Price"><i class="uis uis-dollar-alt mr-1"></i>Price: -</small>
                                            <h5 class="col-8 dis-flex text-sm-b text-blue pl-2 pr-0" title="Sell Price">1,40
                                                <span class="text-sm-d ml-1">€</span>
                                            </h5>
                                        </div>
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en" title="Purchase price"><i class="uis uis-invoice mr-1"></i>P-Prc: -</small>
                                            <h5 class="col-8 dis-flex text-sm-d pl-2 pr-0" title="Purchase price">0,89
                                                <span class="text-sm-d ml-1">€</span>
                                            </h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en" title="Actual Price with Discount"><i class="uis uis-percentage mr-1"></i>Price: -</small>
                                            <h5 class="col-8 dis-flex text-sm-b text-rose pl-2 pr-0" title="Actual Price with Discount">0,801
                                                <span class="text-sm-d ml-1">€</span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div class="dis-flex flex-m flex-c actual-discount pos-absolute p-right-07r p-bottom-03r" title="Actual Discount">
                                        <small class="fw-black fs-10">10 %</small>
                                    </div>
                                </div>

                                <div class="info-product-element dis-flex flex-m text-back client-dashboard pos-relative">
                                    <i class="fs-15 uis uis-angle-double-left text-blue pos-absolute rt-1-5r"></i>
                                    <i class="fs-15 uis uis-angle-double-right text-blue pos-absolute rt-1-1r"></i>
                                    <div class="dis-flex flex-column w-full">
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en" title="Product on Warehouses"><i class="uis uis-building mr-1"></i>Loc: -</small>
                                            <h5 class="col-8 dis-flex text-sm-b text-blue pl-2 pr-0 text-truncate" title="Product on Warehouses">3
                                                <span class="text-sm-d ml-1">Warehouse</span>
                                            </h5>
                                        </div>
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en" title="Product in Shops"><i class="uis uis-store mr-1"></i>Loc: -</small>
                                            <h5 class="col-8 dis-flex text-sm-b text-blue pl-2 pr-0" title="Product in Shops">4
                                                <span class="text-sm-d ml-1">Shop</span>
                                            </h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en" title="Production date"><i class="uis uis-flask mr-2"></i>Prod: -</small>
                                            <h5 class="col-8 dis-flex text-sm-b text-blue pl-2 pr-0 trix-slider-selector" title="Production date">17.10.2023</h5>
                                        </div>
                                        <!-- <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en" title="Actual Quantity"><i class="uis uis-shopping-bag mr-1"></i>Qty: -</small>
                                            <h5 class="col-8 text-sm-b text-blue pl-2 pr-0" title="Actual Quantity">54<small class="text-main-cl fs-12 self-align-en ml-1">Pcs.</small></h5>
                                        </div> -->
                                    </div>
                                </div>

                                <div class="info-product-element dis-flex flex-m text-back client-dashboard pos-relative">
                                    <i class="fs-15 uis uis-angle-double-right text-blue pos-absolute rt-1-1r"></i>
                                    <div class="dis-flex flex-column w-full">
                                        <div class="dis-flex flex-m mb-1"> 
                                            <small class="text-main-cl fs-12 self-align-en" title="SKU Code"><i class="uis uis-label mr-2"></i>SKU: -</small>
                                            <h5 class="col-8 dis-flex text-sm-d pl-2 pr-0 trix-slider-selector" title="SKU Code">0055-WTH-HC</h5>
                                        </div>
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en" title="BAR Code"><i class="fa fa-barcode mr-2"></i>BAR: -</small>
                                            <h5 class="col-8 dis-flex text-sm-b text-blue pl-2 pr-0 trix-slider-selector" title="BAR Code">3029383575095</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en" title="BAR Code"><i class="fa fa-trademark mr-2"></i>Brand: -</small>
                                            <h5 class="col-8 dis-flex text-sm-d pl-2 pr-0 trix-slider-selector" title="Main Label">Crunchy Cheese</h5>
                                        </div>
                                        <!-- <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Size</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Color</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Material</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Fur</h5>
                                        </div> -->
                                    </div>
                                </div>
                            </div>

                            <!-- <div v-trix-horizontal-slider class="any-product-info-blocks-scroll snap-inline-element-info-product product-attribute-overview pt-3 mt--1r" v-else-if="thisProduct.selectedProductMenu == 'attributes'">
                                <div class="dis-flex flex-column h-full pos-relative">
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            <div class="created-attribute-components flex-m pos-relative">
                                                <span class="text-sm-d pr-2 bor-right-1">XS</span>
                                                <div class="dis-flex felx-m pl-2" title="Stock for Size">
                                                    <span class="text-sm-b text-rose text-new-light">108</span>
                                                </div>
                                            </div>
                                            <div class="created-attribute-components flex-m pos-relative">
                                                <span class="text-sm-d pr-2 bor-right-1">S</span>
                                                <div class="dis-flex felx-m pl-2" title="Stock for Size">
                                                    <span class="text-sm-b text-rose text-new-light">14</span>
                                                </div>
                                            </div>
                                            <div class="created-attribute-components flex-m pos-relative">
                                                <span class="text-sm-d pr-2 bor-right-1">L</span>
                                                <div class="dis-flex felx-m pl-2" title="Stock for Size">
                                                    <span class="text-sm-b text-rose text-new-light">37</span>
                                                </div>
                                            </div>
                                            <div class="created-attribute-components flex-m pos-relative">
                                                <span class="text-sm-d pr-2 bor-right-1">M</span>
                                                <div class="dis-flex felx-m pl-2" title="Stock for Size">
                                                    <span class="text-sm-b text-rose text-new-light">9</span>
                                                </div>
                                            </div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dis-flex flex-column h-full">
                                    <div class="text-back small-header mb-1 dis-flex flex-m">
                                        <i class="uis uis-exclamation fs-15 text-rose m-l--4"></i>
                                        <span class="text-main-cl fs-11 self-align-en">Size</span>
                                        <small class="text-rose txt-italic fs-10 self-align-en ml-auto">Attribute</small>
                                    </div>
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">XS</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">S</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">L</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">M</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">XXL</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">36</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">37</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">38</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">41</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">42</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dis-flex flex-column h-full">
                                    <div class="text-back small-header mb-1 dis-flex flex-m">
                                        <i class="uis uis-camera fs-12 text-rose"></i>
                                        <span class="text-main-cl fs-11 self-align-en ml-1">Material</span>
                                        <small class="text-rose txt-italic fs-10 self-align-en ml-auto">Attribute</small>
                                    </div>
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dis-flex flex-column h-full">
                                    <div class="text-back small-header mb-1 dis-flex flex-m">
                                        <i class="uis uis-font fs-12 text-rose"></i>
                                        <span class="text-main-cl fs-11 self-align-en ml-1">Weight</span>
                                        <small class="text-rose txt-italic fs-10 self-align-en ml-auto">Attribute</small>
                                    </div>
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        thisProduct: {
            type: Object,
            required: true
        },
        selectedLang: {
            type: String,
            required: true
        },
        selectForDelete: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            mobileActionBtnsOpened: false,
        }
    },
    methods: {
        selectThisProductForDelete: function(event, thisProdObj) {
            if (event.target.checked) {
                thisProdObj.selectedForDelete = true;
            } else {
                thisProdObj.selectedForDelete = false;
            }
        }
    }
}
</script>

<style>

</style>